import { configureStore } from "@reduxjs/toolkit";
import cardsReducer from "./cardsSlice";
import aboutReducer from "./aboutSlice";
import spreadsReducer from "./spreadsSlice"; 

export const store = configureStore({
  reducer: {
    cards: cardsReducer,
    about: aboutReducer,
    spreads: spreadsReducer, 
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
